export default [
  {
    skillsTitle: "Front-End",
    skillsList: ["HTML", "CSS", "JavaScript", "React", "Jest"],
    skillsIcon: "fa-code",
  },
  {
    skillsTitle: "Back-End",
    skillsList: ["Node.js", "Java (Springboot)", "Ruby (Rails)"],
    skillsIcon: "fa-database",
  },
  {
    skillsTitle: "Other Tools",
    skillsList: ["PostgreSQL", "MySQL", "Docker", "AWS", "CI/CD pipelines"],
    skillsIcon: "fa-chart-bar",
  },
];
